import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import {GoogleReCaptchaProvider} from 'react-google-recaptcha-v3';

ReactDOM.render(
    <React.StrictMode>
        <GoogleReCaptchaProvider
            useRecaptchaNet
            reCaptchaKey={process.env.REACT_APP_SITE_KEY}
            scriptProps={{async: true, defer: true, appendTo: 'body'}}
        >
            <App/>
        </GoogleReCaptchaProvider>
    </React.StrictMode>,
    document.getElementById('root')
);
